import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

/**
 * Hover tooltip for a favourite drug chip. Surfaces the extra prescription
 * details that don't fit on the chip label (which shows only the description):
 * quantity, refills, pharmacy name and sig. Mirrors the label/value layout of
 * the rx-pad DrugDscTooltip so it feels native to the app.
 */
export default function FavouriteDrugTooltip(props: { row: any }) {
  const { row } = props;

  const quantity =
    row?.quantity == null || row?.quantity === ""
      ? "Not Available"
      : `${row.quantity}${row?.quantityQualifier ? ` ${row.quantityQualifier}` : ""}`;

  const rows: Array<[string, string]> = [
    ["Quantity", quantity],
    ["Refills", row?.refills == null ? "Not Available" : String(row.refills)],
    ["Pharmacy", !row?.pharmacyName ? "Not Available" : row.pharmacyName],
    ["Sig", !row?.sig ? "Not Available" : row.sig],
  ];

  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      {row?.description && (
        <Grid item xs={12}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            {row.description}
          </Typography>
        </Grid>
      )}
      {rows.map(([label, value]) => (
        <Grid container item xs={12} key={label} columnSpacing={2} rowSpacing={0}>
          <Grid item xs={5} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              {label}:
            </Typography>
          </Grid>
          <Grid item xs={7} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {value}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
